module.exports = __webpack_public_path__ + "static/media/localBankTransferIcon.08fa9887.svg";